import { ensureServiceWorkerAwake, SwWakeResult } from './ensureServiceWorkerAwake';

/** Upper bound on how long waking the worker may delay a request. */
export const WAKE_CAP_MS = 6_000;

/**
 * Wakes the worker, waiting at most `WAKE_CAP_MS`. Best-effort: never rejects,
 * a request is sent anyway when the worker does not answer.
 */
export async function wakeServiceWorkerBeforeRequest(): Promise<SwWakeResult> {
  let capTimer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      ensureServiceWorkerAwake(),
      new Promise<SwWakeResult>((resolve) => {
        capTimer = setTimeout(() => resolve(SwWakeResult.error), WAKE_CAP_MS);
      }),
    ]);
  } catch {
    return SwWakeResult.error;
  } finally {
    // Runs before every request: do not leave a timer behind for each one.
    clearTimeout(capTimer);
  }
}
